export default __webpack_public_path__ + "static/media/icon7.cca2788b.svg";